import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react"

import { cn, TableHead } from "@atlant/ui"

export type SortDir = "asc" | "desc"

export const headClass = "text-muted-foreground h-10 text-xs font-medium uppercase"

interface SortableHeadProps {
  label: string
  active: boolean
  dir: SortDir
  onSort: () => void
  className?: string
}

export const SortableHead = ({
  label,
  active,
  dir,
  onSort,
  className,
}: SortableHeadProps) => {
  const Icon = !active ? ArrowUpDown : dir === "asc" ? ArrowUp : ArrowDown
  return (
    <TableHead
      aria-sort={active ? (dir === "asc" ? "ascending" : "descending") : "none"}
      className={cn(headClass, className)}
    >
      <button
        type="button"
        onClick={onSort}
        className={cn(
          "hover:text-foreground inline-flex items-center gap-1 whitespace-nowrap uppercase",
          active && "text-foreground",
        )}
      >
        {label}
        <Icon className={cn("size-3.5", !active && "opacity-60")} />
      </button>
    </TableHead>
  )
}
